import { makeStyles } from '@material-ui/core/styles';
import { convertPxToRem } from '../../common/utils/helpers/GenericHelpers';

export const useStyles = makeStyles((theme) => ({
    textWrapper: {
        '& h4': {
            margin: '0 0 20px 0',
        },
    },
    pretty: {
        minWidth: 430,
        minHeight: 460,
    },
    spinnerContainer: {
        position: 'relative',
        '& div': {
            position: 'absolute',
            top: convertPxToRem(12),
            left: 'calc(50% - 12px)',
        },
    },
    inputPhone: {
        '& input[type="tel"]': {
            backgroundColor: '#f7f8f7',
        },
    },
    form: {
        '& p.Mui-error': {
            fontSize: '0.75rem',
        },
    },
}));
